import { getCatalogById } from "./getCatalogById";
import { getFieldInfo } from "./getFieldInfo";
import { getObjectById } from "./getObjectById";

export const getTextToShow = (selectedField, dataObject, listFieldsTechnology, 
  listFullCatalogs, listFullCatalogCiius, countriesAll, regionsAll, continents) => {
  const fieldFound = getFieldInfo(selectedField.field, listFieldsTechnology);
  
  if (fieldFound.is_comparable) {
    const idField = dataObject[selectedField.field];
    if (fieldFound.comparable_relation_condition === "Fields") {
     
      return dataObject[selectedField.field];
    }
    else if (fieldFound.comparable_relation_condition === "Catalogs") {
     
      const relationValue = getCatalogById(idField, listFullCatalogs);
      return relationValue?.description;

    } else if (fieldFound.comparable_relation_condition === "CatalogCiius") {

      const elementFoundLevel = getObjectById(idField, listFullCatalogCiius);
      return elementFoundLevel.name;

    } else if (fieldFound.comparable_relation_condition === "CatalogCountries") {
     
      const elementFoundLevel = getObjectById(idField, countriesAll);
      return elementFoundLevel.name;

    } else if (fieldFound.comparable_relation_condition === "CatalogRegions") {
     
      const elementFoundLevel = getObjectById(idField, regionsAll);
      return elementFoundLevel.name;

    } else if (fieldFound.comparable_relation_condition === "CatalogContinents") {
     
      const elementFoundLevel = getObjectById(idField, continents);
      return elementFoundLevel.name;

    } else if (fieldFound.comparable_relation_condition === "Year") {
     
    
      const today = new Date(dataObject[selectedField.field]);
     
      const yyyy = today.getFullYear();
    
      return yyyy;

    }
  }
}